import axios from "axios";
import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const expensesService = {
    getAll: async (params = {}) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const queryParams = new URLSearchParams();

        if (params.page) queryParams.append("page", params.page);
        if (params.limit) queryParams.append("limit", params.limit);
        if (params.category) queryParams.append("category", params.category);
        if (params.startDate) queryParams.append("startDate", params.startDate);
        if (params.endDate) queryParams.append("endDate", params.endDate);
        if (params.search) queryParams.append("search", params.search);

        const response = await axiosInstance.get(`${baseUrl}expenses?${queryParams.toString()}`);
        return response.data;
    },

    getCategories: async () => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(`${baseUrl}expenses/categories`);
        return response.data;
    },

    create: async (expenseData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.post(`${baseUrl}expenses`, expenseData);
        return response.data;
    },

    update: async (id, expenseData) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.put(`${baseUrl}expenses/${id}`, expenseData);
        return response.data;
    },

    delete: async (id) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.delete(`${baseUrl}expenses/${id}`);
        return response.data;
    },
};
